/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Account } from './account';
import { LakeUser } from './lakeUser';

export interface SystemLog {
  id?: number;
  userId?: number;
  user?: LakeUser;
  timestamp?: string;
  accountId?: number;
  account?: Account;
  reportingCodeId?: number;
  message?: string;
}
